import {FooterItem} from '@constellation/core';
import {type VFC, Fragment} from 'react';
import {styled} from 'styled-components';
import {JOURNEY_EVENT} from '../../../../enums/tagging/index.js';
import FooterLink from '../FooterLink/FooterLink.js';

const FooterContentSectionWrapper = styled.section`
  ${(props) => `
  display: flex;
  @media (max-width: ${props.theme.breakpoint_lg}) {
    display: block;
  }
`}
`;

type footerContent = {
  text: string;
  link: string;
};

type footerContentProps = {
  footerContent: footerContent[];
};

const FooterContent: VFC<footerContentProps> = ({footerContent}) => (
  <FooterContentSectionWrapper data-testid='footerContent'>
    {footerContent.length > 0 &&
      footerContent.map((content) => (
        <Fragment key={content.text}>
          <FooterItem>
            <FooterLink
              journeyEvent={JOURNEY_EVENT.EXTERNAL_CLICK}
              link={content.link}
              taggingLabel={content.text}
              text={content.text}
            />
          </FooterItem>
        </Fragment>
      ))}
  </FooterContentSectionWrapper>
);

export default FooterContent;
